import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { SippApi } from '../../../services/SippExpress'
import {
  WaterTestKitRequest,
  WaterTestKitRequestsInitialState,
} from '../waterTestKitRequests.slice'

export const fetchWaterTestKitRequestsAsync = createAsyncThunk<
  Partial<WaterTestKitRequest>[],
  AxiosRequestConfig
>('waterTestKits/fetchByEmail', async (options, { rejectWithValue }) => {
  try {
    const response = (await SippApi.fetchWaterTestKitRequests(options)) as AxiosResponse<
      Partial<WaterTestKitRequest>[]
    >
    return response.data
  } catch (err: any) {
    return rejectWithValue(
      err.response?.data || {
        message: 'Unexpected error occurred',
        errors: [],
      },
    )
  }
})

export const fetchWaterTestKitRequestsBuilder = (
  builder: ActionReducerMapBuilder<WaterTestKitRequestsInitialState>,
) => {
  builder.addCase(fetchWaterTestKitRequestsAsync.pending, (state) => {
    state.loading = true
    state.error = false
  })
  builder.addCase(fetchWaterTestKitRequestsAsync.fulfilled, (state, action) => {
    state.loading = false
    state.error = false
    state.data = action.payload
  })
  builder.addCase(fetchWaterTestKitRequestsAsync.rejected, (state) => {
    state.loading = false
    state.error = true
  })
}
